/**
 * PlayAllIcon/index.js
 * desc: play all icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const PlayAllIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="play-all icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.playAll.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 15 19" xmlns="http://www.w3.org/2000/svg"><path d="M0.208984 1.45258V17.2635C0.209009 17.4518 0.259758 17.6366 0.355865 17.7984C0.451971 17.9602 0.589864 18.0929 0.754962 18.1825C0.92006 18.2721 1.10623 18.3153 1.29378 18.3075C1.48133 18.2997 1.6633 18.2412 1.82044 18.1382L13.8663 10.2327C14.0111 10.1377 14.1301 10.008 14.2125 9.85528C14.2948 9.70256 14.3379 9.53167 14.3379 9.35805C14.3379 9.18442 14.2948 9.01353 14.2125 8.86082C14.1301 8.70811 14.0111 8.57839 13.8663 8.48338L1.82044 0.577912C1.6633 0.474904 1.48133 0.416408 1.29378 0.408611C1.10623 0.400814 0.92006 0.444005 0.754962 0.533617C0.589864 0.623229 0.451971 0.755932 0.355865 0.917695C0.259758 1.07946 0.209009 1.26427 0.208984 1.45258Z"/></svg>
    </IconButton>
);


export default PlayAllIcon;
